export enum EXPORT_ITEMS {
	PLANNING = 'PLANNING',
	RECOLTE_THEORIQUE_SEMAINE = 'RECOLTE_THEORIQUE_SEMAINE'
}

export const DETAIL_DATA_TACHE_FIELDS = {
	RECOLTE: {
		RECOLTE_ENTIERE: 'recolteEntiere'
	},
	TRI: {
		QUANTITE_CALIBREE: 'quantiteCalibree',
		QUANTITE_HORS_CALIBRE: 'quantiteHorsCalibre',
		QUANTITE_NON_COMMERCIALISABLE: 'quantiteNonCommercialisable'
	},
	FERTILISATION: {
		QUANTITE_FERTILISANT: 'quantiteFertilisant',
		PRODUIT_FERTILISANT: 'produitFertilisant'
	},
	TEMPS_PASSE_USER: 'tempsPasseUser',
}

export const SOLVER_TASK_PERIOD = {
	WEEKS: 'WEEKS',
	DAYS: 'DAYS'
}